import {IApplicationState} from '../../../types/types';

export const getActiveBoardId = (
    state: IApplicationState
): number => {
    return state.model.activeDashboardId;
};
